import { Service } from '@tino-frontend/adapters'
import {
  GetMerchantInstallmentsResponse,
  GetMerchantPrimaryContactParams,
  GetMerchantPrimaryContactResponse,
  ListMerchantParams,
  ListMerchantsResponse,
  MerchantDetails,
  SendBoletoToMerchantPayload,
  SalespersonMetricsResponse,
} from '@types'
import { cleanPhone } from './transformers/phone.transform'

export class SalespersonService {
  constructor(private readonly supplierBFF: Service) {}

  async listSalespersonMerchants(
    salespersonId: string,
    params?: Partial<ListMerchantParams>
  ): Promise<ListMerchantsResponse> {
    return this.supplierBFF.get(`/v1/salespersons/${salespersonId}/merchants`, {
      params,
    })
  }

  async getMerchantInfo(
    salespersonId: string,
    merchandDocumentNumber: string
  ): Promise<MerchantDetails> {
    return this.supplierBFF.get(
      `/v1/salespersons/${salespersonId}/merchants/${merchandDocumentNumber}`
    )
  }

  async getSalespersonMetrics(
    salespersonId: string
  ): Promise<SalespersonMetricsResponse> {
    return this.supplierBFF.get(`/v1/salespersons/${salespersonId}/metrics`)
  }

  async addMerchantToWallet(
    salespersonId: string,
    merchantId: string,
    isActive: boolean
  ): Promise<void> {
    return this.supplierBFF.post(
      `/v1/salespersons/${salespersonId}/merchants/${merchantId}/associate`,
      {
        is_active: isActive,
        origin: 'self_association',
      }
    )
  }

  async getMerchantPrimaryContact(
    merchantId: string,
    params: GetMerchantPrimaryContactParams
  ): Promise<GetMerchantPrimaryContactResponse> {
    try {
      const { contact }: GetMerchantPrimaryContactResponse =
        await this.supplierBFF.get(
          `/v1/merchants/${merchantId}/primary_user_contact`,
          { params }
        )

      return {
        contact: {
          ...contact,
          phone: contact.phone ? cleanPhone(contact.phone) : '',
        },
      }
    } catch (e) {
      return Promise.reject(e)
    }
  }

  async getMerchantInstallments(
    supplier_id: string,
    merchantId: string
  ): Promise<GetMerchantInstallmentsResponse> {
    return this.supplierBFF.get(
      `v1/suppliers/${supplier_id}/merchants/${merchantId}/installments`
    )
  }

  async sendBoletoToMerchant(id: string, params: SendBoletoToMerchantPayload) {
    return this.supplierBFF.post(
      `/v1/installments/${id}/send-to-merchant`,
      params
    )
  }
}
